import * as RadioGroup from '@radix-ui/react-radio-group';
import { forwardRef } from 'react';
import { SurveyRadioItem } from './survey-radio-item';

export interface Data {
  no_code_experience?: NoCodeExperienceLevel;
}

type NoCodeExperienceLevel = 'beginner' | 'basic' | 'intermediate' | 'advanced';

const NO_CODE_EXPERIENCE: Array<{ key: NoCodeExperienceLevel; value: string; note: string }> = [
  { key: 'beginner', value: 'Beginner', note: '(First time building with AI/no-code tools)' },
  { key: 'basic', value: 'Basic', note: "(I've used AI/no-code tools to build before)" },
  { key: 'intermediate', value: 'Intermediate', note: "(I'm comfortable building apps with AI/no-code tools)" },
  { key: 'advanced', value: 'Advanced', note: "(I've built fully-featured apps using AI/no-code tools)" },
];

interface Props {
  initialValues?: Data;
  className?: string;
}

const SurveyStep3B = forwardRef<HTMLDivElement, Props>(({ initialValues, className }, ref) => (
  <div className={className} ref={ref}>
    <h2 className="text-[32px]/[39px] font-semibold text-pretty max-w-[400px]">
      How would you describe your AI/No-code building experience?
    </h2>

    <RadioGroup.Root
      defaultValue={
        typeof initialValues?.no_code_experience === 'string' ? initialValues?.no_code_experience : undefined
      }
      name="no_code_experience"
      aria-label="No code experience"
      className="mt-8 grid gap-3 w-full"
      required
    >
      {NO_CODE_EXPERIENCE.map((experience) => (
        <SurveyRadioItem
          key={experience.key}
          value={experience.key}
          id={`no_code_experience-${experience.key}`}
          className="py-3 px-4"
        >
          <div className="font-semibold">{experience.value}</div>
          <div>{experience.note}</div>
        </SurveyRadioItem>
      ))}
    </RadioGroup.Root>
  </div>
));

SurveyStep3B.displayName = 'SurveyStep3B';

export default SurveyStep3B;
